export function AlertBanner({ message }: { message: string }) {
  return (
    <div
      role="status"
      className="rounded-2xl bg-[var(--sf-primary)] px-4 py-3 text-[14.5px] font-medium leading-snug text-white shadow-sm"
    >
      {message}
    </div>
  );
}
